import React from "react";
import { Box, Typography } from "@mui/material";
import "./Footer.css"; // Import the CSS file for styling

const Footer = () => {
  return (
    <Box component="footer" className="footerStyling">
      <Typography variant="caption2" className="footerText">
      © {new Date().getFullYear()} TivaraX. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
